import { vars } from 'braid-design-system/css';

interface CircularProgressProps {
  progress: number;
}

const CircularProgress = ({ progress }: CircularProgressProps) => {
  const strokeWidth = 5;
  const radius = 49;
  const defaultStroke = vars.foregroundColor.info;
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;
  return (
    <svg height={radius * 2} width={radius * 2}>
      <circle
        stroke={defaultStroke}
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeDasharray={`${circumference} ${circumference}`}
        style={{
          strokeDashoffset,
          transform: 'rotate(-90deg)',
          transformOrigin: '50% 50%',
        }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  );
};

export default CircularProgress;
